<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/changshu/cs.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Changshu Electronics Plant
                </div>
                <div class="manufacture-t2">
                    Located in Changshu, Jiangsu, it provides intelligent system solutions for smart cockpits and mobility with controllers, displays and audio products.
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                Production Capacity
            </div>
            <div class="page-t2">
                The plant is capable of process design and development for SMT, soldering, assembly and testing.
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">
                                Low/medium/high-speed mounting
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">
                                
                                3D solder paste inspection (SPI)
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">
                                
                                0201/BGA/connector mounting
                                
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">
                                Automatic optical inspection (AOI)
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-4.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">
                                
                                Laser marking
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-5.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Surface Mount Technology (SMT)
                            </div>
                            <div class="destils">

                                X-Ray inspection
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-6.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                
            </div>
            <div class="page-t2">
                
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                PCB Circuit Board Processes
                            </div>
                            <div class="destils">
                                Board separation
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                PCB Circuit Board Processes
                            </div>
                            <div class="destils">
                                Selective soldering
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                PCB Circuit Board Processes
                            </div>
                            <div class="destils">

                                Conformal coating spraying
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                
            </div>
            <div class="page-t2">
                
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Final Assembly
                            </div>
                            <div class="destils">
                                Dispensing system
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Final Assembly
                            </div>
                            <div class="destils">

                                Error-proofing/visual inspection
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Final Assembly
                            </div>
                            <div class="destils">
                                
                                Automatic screw fastening assembly
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Final Assembly
                            </div>
                            <div class="destils">
                                Crimping
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">

            </div>
            <div class="page-t2">

            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Testing & Factory Information Systems
                            </div>
                            <div class="destils">
                                In-Circuit Test (ICT)
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Testing & Factory Information Systems
                            </div>
                            <div class="destils">
                                
                                Program burning
                                
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Testing & Factory Information Systems
                            </div>
                            <div class="destils">
                                Normal temperature / High temperature test
                            </div>
                        </div>
                        
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Testing & Factory Information Systems
                            </div>
                            <div class="destils">
                                
                                Factory Information System (ERP/MOM/SAP, etc.)
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Changshu Electronics Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/el/changshu.html'
};

import { createApp } from 'vue';
import App from './changshu.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./changshu.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
